var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ECase',{staticClass:"mb-4"}),_c('FilterOptions',{staticClass:"mb-4"}),_c('History',{staticClass:"mb-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }